import { CalendarIcon, ClockIcon } from "@heroicons/react/solid";
import React from "react";
import { useTranslation } from "react-i18next";
import SessionModel from "../../api/models/SessionModel";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import { classNames } from "../../helpers";

type CardSessionPropsTypes = {
  session: SessionModel | null;
};
export default function CardSession(props: CardSessionPropsTypes) {
  const { session } = props;
  const LocalBasePath = "page.supervisor.sessions";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  return (
    <div className="flex  px-4 md:px-6  flex-col w-full gap-4 md:border-b md:border-gray-300 pb-4">
      <div className="flex justify-between gap-4 md:gap-0 md:items-center flex-col md:flex-row">
        <div className="flex gap-4 md:items-center  flex-col md:flex-row">
          <div className="flex  justify-between items-center">
            <p className="text-gray-800 font-semibold text-[22px] leading-8">
              {t("sessionNumber", { session: session?.sessionNumber ?? "" })}
            </p>
            <div className="md:hidden">
              {session?.status && (
                <span
                  className={classNames(
                    "text-base leading-4 font-medium  rounded-[10px] py-1.5 px-3",
                    session?.status == "terminated_early" &&
                      "text-yellow-500 bg-[#FEFCE8] ",
                    session?.status == "completed" &&
                      "bg-green-100 text-green-800"
                  )}
                >
                  {t(session?.status)}
                </span>
              )}
            </div>
          </div>

          <div className="flex  items-center  gap-4">
            <p className="text-gray-500 font-medium text-sm flex gap-1 items-center">
              <CalendarIcon className="w-4 h-4 text-gray-500" />
              {session?.date?.format("dddd YYYY-MM-DD ")}
            </p>
            <p className="text-gray-500 font-medium text-sm flex gap-1 items-center">
              <ClockIcon className="w-4 h-4 text-gray-500" />
              {session?.start_time?.format("HH:mm")}
            </p>
          </div>
        </div>
        <div className="flex gap-6 items-center">
          <div className="flex gap-2  flex-1 items-start">
            <div className="w-12 h-[52px] relative">
              <UserProfilePictureAvatar
                className="w-10 h-10 left-0 top-0 absolute rounded-full"
                profilePictureUrl={session?.student?.profile_picture_url}
                alt=""
              />
              <UserProfilePictureAvatar
                className="w-8 h-8 left-4 top-5 absolute rounded-full border border-white"
                profilePictureUrl={session?.tutor?.profile_picture_url}
                alt=""
              />
            </div>
            <div className=" h-[52px] flex-col justify-center items-end inline-flex">
              <div className="self-stretch  text-gray-800 text-lg font-semibold leading-[27px]">
                {session?.student?.firstName + " " + session?.student?.lastName}
              </div>
              <div className="self-stretch  text-gray-500 text-sm font-normal leading-tight">
                {session?.tutor?.firstName + " " + session?.tutor?.lastName}
              </div>
            </div>
          </div>
          <div className="hidden md:block">
            {session?.status && (
              <span
                className={classNames(
                  "text-base leading-4 font-medium  rounded-[10px] py-1.5 px-3",
                  session?.status == "terminated_early" &&
                    "text-yellow-500 bg-[#FEFCE8] ",
                  session?.status == "completed" &&
                    "bg-green-100 text-green-800"
                )}
              >
                {t(session?.status)}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="w-full flex items-center justify-between">
        <div className="flex flex-col gap-0.5 ">
          <p className="text-brandblue-500 text-base  leading-5 font-semibold">
            {t("pages", { count: session?.sessionStudentEndPageNumber ?? 0 })}
          </p>
          <p className="text-gray-500 text-xs ">{t("finishedPages")}</p>
        </div>
        <div className="flex flex-col gap-0.5 ">
          <p className="text-brandblue-500 text-base  leading-5 font-semibold">
            {session?.session_duration ?? "-"}
          </p>
          <p className="text-gray-500 text-xs ">{t("sessionDuration")}</p>
        </div>
        <div className="flex flex-col gap-0.5 ">
          <p className="text-brandblue-500 text-base  leading-5 font-semibold">
            {session?.latency ?? "-"}
          </p>
          <p className="text-gray-500 text-xs ">{t("studentLate")}</p>
        </div>
        <div className="flex flex-col gap-0.5 ">
          <p className="text-brandblue-500 text-base  leading-5 font-semibold">
            {session?.tutor_tardiness ?? "-"}
          </p>
          <p className="text-gray-500 text-xs ">{t("tutorLate")}</p>
        </div>
      </div>
    </div>
  );
}
